import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import SearchField from "../../components/layout/SearchField";
import { IoAddCircleSharp } from "react-icons/io5";
import { MdDashboard } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FaAngleRight, FaArrowRight, FaChevronRight } from "react-icons/fa";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { AddButton } from "../../components/layout/CustomTable";
import { MotionDiv } from "../../components";
import DomainHeader from "../../components/layout/DomainHeader";
import {
  useGetSubTopicsMutation,
  useGetTopicsMutation,
} from "../../features/apiSlice";
import { getError } from "../../utils/error";
import Skeleton from "react-loading-skeleton";
import { fetchSubtopics, fetchTopics } from "../../utils/apis";
import { useDispatch, useSelector } from "react-redux";
import { selectOptions, setTopic, unsetTopic } from "../../features/optionSlice";
import BackBtn from "../../components/layout/BackBtn";

function TopicSubtopic() {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [getTopics, { isLoading: topicLoading }] = useGetTopicsMutation();
  const [getSubtopics, { isLoading: subtopicLoading }] = useGetSubTopicsMutation();
  const [topics, setTopics] = useState([]);
  const [subtopics, setSubtopics] = useState([]);
  const [topicQuery, setTopicQuery] = useState("");
  const [selectedTopic, setSelectedTopic] = useState('');
  const [subTopicQuery, setSubTopicQuery] = useState("");

  // const { id } = useParams();
  const {subdomain,topic} = useSelector(selectOptions);

  // const fetchTopics = async()=>{
  //     try {
  //       const data = await getTopics(id).unwrap();
  //       console.log(data);
  //       setTopics(data?.topics);
  //     } catch (error) {
  //       getError(error)
  //     }
  //   }

  // const fetchSubtopics = async()=>{
  //     try {
  //       const data = await getSubtopics(topic).unwrap();
  //       console.log(data);
  //       setSubtopics(data?.subTopics);
  //     } catch (error) {
  //       getError(error)
  //     }
  //   }

  useEffect(() => {
    setSelectedTopic('')
    dispatch(unsetTopic())
    if(subdomain){
      fetchTopics({ setTopics, id:subdomain, getTopics, params: `key=${topicQuery}` });
    }

  }, [topicQuery,subdomain]);

  useEffect(() => {
    if (topic) {
      fetchSubtopics({
        setSubtopics,
        id: topic,
        getSubtopics,
        params: `key=${subTopicQuery}`,
      });
    }
  }, [topic, subTopicQuery]);

  useEffect(() => {
    if (topics.length > 0) {
      dispatch(setTopic(topics[0]?._id));
      setSelectedTopic(topics[0]?.topic_name)
    }
  }, [topics]);



  return (
    <MotionDiv>
      <DomainHeader />

      <Row>
        <Col className='p-1'>
        
       <BackBtn/>
        </Col>
       </Row>
    
      {/* <Row className="my-3">
        <Col className="text-end">
          Exam/Certification By:{" "}
          <u style={{ color: "rgba(128, 152, 249, 1)" }}>Edicexam.com</u>
        </Col>
      </Row> */}
      <Row className="">
        <Col className="p-1 me-1">
          <Card className="p-4 rounded-3 border h-100">
            <p className="pt-3 mt-2">
              {/* Selected Area of Speciality: <span>Mechanical Engineering</span> */}
            </p>
            <Row>
              <Col sm={7}>
                <SearchField
                  query={topicQuery}
                  setQuery={setTopicQuery}
                  placeholder="Search Topic"
                />
              </Col>
              <Col className="justify-content-end d-flex align-items-center">
                {subdomain && (
                  <Button
                    onClick={()=>navigate(`/admin/domains/all-topics`)}
                    className='add-btn'
                    variant="transparent"
                  >
                   
                      View/Edit <FaChevronRight />
                   
                  </Button>
                )}
              </Col>
            </Row>
            <h5 className="mt-3">Topics included in it:</h5>
            <div className="px-4">
            {topicLoading ? (
              [...Array(8)].map((_, index) => (
                <Skeleton height={"2rem"} className="mb-2" key={index} />
              ))
            ) : topics?.length > 0 ? (
              topics?.map((item, index) => (
                <Row key={item?._id} >
                <Col className="p-1" >
                  <div
                    className={`w-100 d-flex justify-content-between align-items-center border rounded p-2  ${
                      topic === item?._id ? "selected-topic" : ""
                    }`}
                    onClick={() =>{
                     setSelectedTopic(item?.topic_name)   
                     dispatch(setTopic(item?._id))
                    
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <span>{item?.topic_name}</span>
                    <FaAngleRight />
                  </div>
                </Col>
                </Row>
              ))
            ) : (
              <p>No topics</p>
            )}
            </div>
          </Card>
        </Col>
        <Col className="p-1 ms-1">
          <Card className="p-4 border rounded-3 h-100">
            <p>
              Selected Topic: <span>{selectedTopic}</span>
            </p>
            <Row>
              <Col sm={7}>
                <SearchField
                  placeholder="Search Subtopic"
                  query={subTopicQuery}
                  setQuery={setSubTopicQuery}
                />
              </Col>
              <Col className="justify-content-end d-flex align-items-center">
                {topic &&(
                  <Button
                  onClick={()=>navigate(`/admin/domains/all-subtopics`)}
                  className='add-btn'
                  variant="transparent"
                >
                 
                    View/Edit <FaChevronRight />
                 
                </Button>
                )}
              </Col>
            </Row>
            <h5 className="mt-3">Subtopics included in it:</h5>
            {subtopicLoading ? (
              [...Array(8)].map((_, index) => (
                <Skeleton height={"2rem"} className="mb-2" key={index} />
              ))
            ) : subtopics?.length > 0 ? (
              subtopics?.map((item, index) => (
                <Row key={item?._id}>
                <Col className="p-1" >
                  <div
                    className="d-flex justify-content-between align-items-center   p-2 "
                    style={{
                      borderLeft: "1px solid rgba(45, 50, 130, 1)",
                      color: "rgba(45, 50, 130, 1)",
                      maxWidth: "500px",
                    
                    }}
                  >
                    <span>{item?.sub_topic_name}</span>
                    {/* <FaAngleRight /> */}
                  </div>
                </Col>
                </Row>
              ))
            ) : (
              <p>No Subtopics</p>
            )}
          </Card>
        </Col>
      </Row>
    </MotionDiv>
  );
}

export default TopicSubtopic;
